import { useTranslation } from "react-i18next";
import "bootstrap/dist/css/bootstrap.min.css";
import {
  FaDollarSign,
  FaFile,
  FaMoneyBillWave,
  FaSearch,
  FaShoppingBag,
  FaUsers,
} from "react-icons/fa";

const SingleWindow = () => {
  const { t } = useTranslation();

  const CustomIcon = ({ symbol }) => (
    <div
      style={{
        color: "rgb(12, 63, 40)",
        fontSize: "clamp(20px, 4vw, 28px)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: "100%",
        height: "100%",
      }}
    >
      {symbol}
    </div>
  );

  const icons = [
    <FaMoneyBillWave />,
    <FaUsers />,
    <FaShoppingBag />,
    <FaFile />,
    <FaDollarSign />,
    <FaSearch />,
  ];

  const services = t("singleWindow.services", { returnObjects: true });

  return (
    <div className="container py-5">
      <div className="text-center mb-5">
        <h1
          className="fw-bold mb-3"
          style={{
            color: "rgb(12, 63, 40)",
            fontSize: "clamp(1.75rem, 5vw, 2.5rem)",
          }}
        >
          {t("singleWindow.title")}
        </h1>
        <p
          className="lead"
          style={{
            fontSize: "clamp(1rem, 2.5vw, 1.25rem)",
          }}
        >
          {t("singleWindow.subtitle")}
        </p>
      </div>

      <div className="row g-4">
        {services.map((service, index) => (
          <div key={index} className="col-12 col-sm-6 col-md-4 col-lg-6">
            <div className="d-flex align-items-start">
              <div
                className="bg-light rounded-circle p-3 me-3 d-flex align-items-center justify-content-center flex-shrink-0"
                style={{
                  width: "70px",
                  height: "70px",
                  minWidth: "70px",
                  minHeight: "70px",
                  maxWidth: "100px",
                  maxHeight: "100px",
                }}
              >
                <CustomIcon symbol={icons[index]} />
              </div>
              <div>
                <h3
                  className="h5 fw-bold mb-1"
                  style={{
                    color: "rgb(12, 63, 40)",
                    fontSize: "clamp(1rem, 3vw, 1.25rem)",
                  }}
                >
                  {service.title}
                </h3>
                <p
                  className="text-muted"
                  style={{
                    fontSize: "clamp(0.875rem, 2.5vw, 1rem)",
                  }}
                >
                  {service.description}
                </p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SingleWindow;
